import React from 'react';
import { AlertTriangle, Shield, BarChart, Clock } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Security Findings feature
 * Displays information about the Security Findings feature and its benefits
 */
export const SecurityFindingsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Security Findings"
      description="Track, analyze, and remediate security vulnerabilities across your entire attack surface with comprehensive findings management."
      icon={<AlertTriangle className="h-8 w-8 text-blue-600" />}
      featureName="security-findings"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertTriangle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Vulnerability Management</h3>
          </div>
          <p className="text-gray-400">
            Centralized dashboard for tracking and managing all security vulnerabilities across your digital assets.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Risk Prioritization</h3>
          </div>
          <p className="text-gray-400">
            Intelligent risk scoring and prioritization to focus remediation efforts on the most critical vulnerabilities.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <BarChart className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Analytics</h3>
          </div>
          <p className="text-gray-400">
            Comprehensive analytics and reporting on security findings to track remediation progress and security posture.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Clock className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Remediation Tracking</h3>
          </div>
          <p className="text-gray-400">
            Track remediation efforts with detailed timelines, assignees, and verification of vulnerability fixes.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
